import { useAuth } from '../hooks/useAuth';
import { formatDateTime } from '../utils/format';

export function AccountPage() {
  const { profile, refreshProfile } = useAuth();

  return (
    <div className="surface" style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem', maxWidth: '640px' }}>
      <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h2 style={{ margin: 0 }}>Account details</h2>
          <p className="text-muted" style={{ margin: 0 }}>Contact your VMGate administrator to request edits.</p>
        </div>
        <button
          type="button"
          onClick={() => refreshProfile()}
          style={{
            border: '1px solid var(--color-border)',
            borderRadius: '10px',
            padding: '0.45rem 0.9rem',
            background: '#fff',
            cursor: 'pointer'
          }}
        >
          Refresh
        </button>
      </header>

      <table className="data-table">
        <tbody>
          <tr>
            <th style={{ width: '35%' }}>Customer ID</th>
            <td>{profile?.customer_id ?? '—'}</td>
          </tr>
          <tr>
            <th>Company name</th>
            <td>{profile?.company_name ?? '—'}</td>
          </tr>
          <tr>
            <th>Contact email</th>
            <td>{profile?.contact_email ?? '—'}</td>
          </tr>
          <tr>
            <th>Contact phone</th>
            <td>{profile?.contact_phone ?? '—'}</td>
          </tr>
          <tr>
            <th>Address</th>
            <td>{profile?.address ?? '—'}</td>
          </tr>
          <tr>
            <th>Status</th>
            <td>{profile?.status ?? '—'}</td>
          </tr>
          <tr>
            <th>Deployment token</th>
            <td style={{ fontFamily: 'monospace', fontSize: '0.85rem', wordBreak: 'break-all' }}>{profile?.deployment_token ?? '—'}</td>
          </tr>
          <tr>
            <th>Installation service</th>
            <td>{profile?.installation_service?.replace(/_/g, ' ') ?? '—'}</td>
          </tr>
          <tr>
            <th>Support contract</th>
            <td>{profile?.support_contract_status?.replace(/_/g, ' ') ?? '—'}</td>
          </tr>
          <tr>
            <th>Created at</th>
            <td>{formatDateTime(profile?.created_at)}</td>
          </tr>
          <tr>
            <th>Updated at</th>
            <td>{formatDateTime(profile?.updated_at)}</td>
          </tr>
          <tr>
            <th>Notes</th>
            <td>{profile?.notes ?? '—'}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

